import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {TrackingDomain} from '../../models/tracking-domain';

@Injectable({
  providedIn: 'root'
})
export class TrackingDomainService extends AbstractModelService<TrackingDomain> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/tracking-domain', TrackingDomain);
  }
}
